import React, { useEffect, useRef } from "react";
import { useLang } from "../i18n/LangContext";
import "../components/MobilePhone.css";

const Screen5: React.FC = () => {
  const { t } = useLang();
  const s = t.screens.s5;
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const notifs = wrapRef.current?.querySelectorAll(".notif");
    notifs?.forEach((n) => {
      const el = n as HTMLElement;
      el.classList.remove("show");
      setTimeout(() => el.classList.add("show"), Number(el.dataset.delay || 0));
    });
  }, []);

  const textParts = s.notifText.split("{project}");

  return (
    <div className="mobile-screen-page" ref={wrapRef}>
      <div className="mobile-wrap">
        <div className="phone">
          <div className="phone-screen">
            <div className="notch" />
            <div className="statusbar">
              <div>09:41</div>
              <div>78%</div>
            </div>
            <div className="phone-content">
              <div className="lock-time">09:41</div>
              <div className="lock-sub">{s.lockSub}</div>
              <div className="notif-wrap">
                <div className="notif" data-delay={400}>
                  <div className="app-icon">W</div>
                  <div className="notif-body">
                    <div className="notif-top">
                      <div>Worklly</div>
                      <div className="notif-time">now</div>
                    </div>
                    <div className="notif-title">{s.notifTitle}</div>
                    <div className="notif-text">
                      {textParts[0]}<strong>{s.projectName}</strong>{textParts[1]}
                    </div>
                    <div className="notif-badge">{s.notifBadge}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="home-indicator" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screen5;
